import PropTypes from 'prop-types'

import { OrderArrivalTolerances } from '../../models/orders/order-arrival-tolerances-enum.js'
import { OrderStates } from '../../models/orders/order-states-enum'
import { OrderTypes } from '../../models/orders/order-types-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { orderAddressPropType } from './order-address-prop-type'
import { orderContactPropType } from './order-contact-prop-type'
import { orderRelationPropType } from './order-relation-prop-type'

/**
 * @typedef {Object} Order
 * @property {string}               [currentState]          - order status, e.g. sent
 * @property {ISO8601}              executionDateTime       - execution date time
 * @property {boolean}              isExecutionTimeSet      - is execution time specified
 * @property {string}               [number]                - order number for user (can be empty for creating order)
 * @property {string}               orderType               - order type
 * @property {number}               [arrivalTolerance]      - minute value for tolerance
 * @property {orderContactPropType} [contact]               - contact info
 * @property {string}               [description]           - order text
 * @property {OrderRelation[]}      [orderRelations]        - array listing the order relation associated to this order
 * @property {orderAddressPropType} [destinationAddress]    - destination address custom format
 * @property {ISO8601}              [lastModifiedTime]      - timestamp of last edit
 * @property {ISO8601}              [estimatedTimeOfArrival] - time until arrival
 * @property {ISO8601Duration}      [estimatedWorkDuration] - estimated duration spent for work on the order
 * @property {ID}                   [orderId]               - order id
 * @property {ID}                   [objectId]              - id of assigned vehicle
 * @property {ISO8601}              [suggestedExecutionTime] - estimated execution date time the order is scheduled for
 * @property {ISO8601}              [timeOfArrival]         - time of arrival
 */
export const orderPropType = PropTypes.shape({
    arrivalTolerance: PropTypes.oneOf(Object.values(OrderArrivalTolerances)),
    contact: orderContactPropType,
    currentState: PropTypes.oneOf(Object.values(OrderStates)),
    description: PropTypes.string,
    destinationAddress: orderAddressPropType,
    estimatedTimeOfArrival: iso8601PropType,
    estimatedWorkDuration: iso8601DurationPropType,
    executionDateTime: iso8601PropType.isRequired,
    isExecutionTimeSet: PropTypes.bool.isRequired,
    lastModifiedTime: iso8601PropType,
    number: PropTypes.string,
    objectId: idPropType,
    orderId: idPropType,
    orderRelations: PropTypes.arrayOf(orderRelationPropType),
    orderType: PropTypes.oneOf(Object.values(OrderTypes)),
    suggestedExecutionTime: iso8601PropType,
    timeOfArrival: iso8601PropType
})
